import { render, staticRenderFns } from "./addzjInfo.vue?vue&type=template&id=84c6d2c2&"
import script from "./addzjInfo.vue?vue&type=script&lang=js&"
export * from "./addzjInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports